import Image from 'next/image'
import React from 'react'

const LoadingSpinner: React.FC = () => {
    return <Image src="/assets/icons/loader.svg" height={100} width={100} alt="Loader" />
}

export default LoadingSpinner
